import React from 'react';
import { CustomFieldType } from '@wix/bex-core';

interface FieldProps {
  dataHook?: string;
  type: CustomFieldType;
  children: React.ReactNode;
}

export const Field = ({ dataHook, type, children }: FieldProps) => {
  return (
    <div data-hook={dataHook} data-field-type={type}>
      {children}
    </div>
  );
};
